import { useState } from 'react'
import anime from 'animejs'

function onFormatBytes(bytes) {
    if (!+bytes) return '0 Bytes'

    const k = 1024

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i) / 1000).toFixed(2))}`
}

export const useTab = (data) => {
    const defaultDataTabs = data?.items?.nodes.map((item) => {
        const arr = data?.files?.nodes?.filter((file) => file.section?.id === item.id)

        return { ...item, items: arr }
    })

    const resultDataTabs = defaultDataTabs?.filter((item) => item.items.length) || []

    const [activeTab, setActiveTab] = useState(resultDataTabs?.[0])

    const onChangeActiveTab = (item) => {
        const content = document.querySelector('.js-governance-content')

        anime({
            targets: content,
            duration: 600,
            easing: 'cubicBezier(0.25, 0.1, 0.25, 1)',
            opacity: [1, 0],
            complete: () => {
                setActiveTab(item)

                anime({
                    targets: content,
                    duration: 600,
                    easing: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                    opacity: [0, 1]
                })
            }
        })
    }

    return { activeTab, onChangeActiveTab, resultDataTabs, onFormatBytes }
}
